import { Pipe, PipeTransform } from '@angular/core';
import * as debug from 'debug';
import * as $ from 'jquery';
import * as _ from 'lodash';

@Pipe({
  name: 'formatWreckerTag',
})
export class FormatWreckerTagsPipe implements PipeTransform {
  log = debug('app:Pipetransform');

  lookUp = {
    mcNumber: 'MC Number',
    usdotNumber: 'USDOT Number',
    authorityLetter: 'Authority Letter',
    fmcsaFiling: 'FMCSA Filing',
    boc3Filing: 'BOC-3 Filing',
    optionalAddOns: 'Optional Add-Ons',
    bocFiling: 'BOC Filing',
    brokerLicense: "Broker's License ",
    ucrPermit: 'UCR Permit',
    sampleContracts: 'Sample Contracts',
  };
  constructor() {}

  transform(tag: string, ...args) {
    const newString = tag
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, function (str) {
        return str.toUpperCase();
      });

    return _.get(this.lookUp, tag) || newString;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-wrecker-tags/format-wrecker-tags.pipe.ts